import Vue from 'vue'
import Router from 'vue-router'
import pc from '@/pages/pc/index'
import homePage from '@/pages/pc/homePage'
import products from '@/pages/pc/products'
import clients from '@/pages/pc/clients'

import m from '@/pages/m/index'
import mHomePage from '@/pages/m/homePage'
import mProducts from '@/pages/m/products'
import mClients from '@/pages/m/clients'

Vue.use(Router)

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/m',
      component: m,
      children: [
        {
          path: 'mClients',
          name: 'mClients',
          component: mClients
        },
        {
          path: 'mProducts',
          name: 'mProducts',
          component: mProducts
        },
        {
          path: '',
          name: 'mHomePage',
          component: mHomePage
        },
      ]
    },
    {
      path: '/',
      component: pc,
      children: [
        {
          path: 'clients',
          name: 'clients',
          component: clients
        },
        {
          path: 'products',
          name: 'products',
          component: products
        },
        {
          path: '',
          name: 'homePage',
          component: homePage
        },
      ]
    },
    {
      path: '*',
      redirect: '/'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js